import React, { useState, useEffect } from 'react';
import './quotes.css'; // Import the CSS file for styling
import NewCustomerDialog from './NewCustomerDialog';
import AddItem from './additem';
import WAppearance from './windows/wint/wappearance';
import SqlInsertGenerator from './docs/templates/lines/SqlInsertGenerator';
import templates from './docs/templates/lines/w16_template'; //

const Quotes = () => {
    const [expandedRows, setExpandedRows] = useState([]); // Track expanded rows
    const [selectedOptions, setSelectedOptions] = useState({});
    const [showDialog, setShowDialog] = useState(false);
    const [inputValues, setInputValues] = useState({});




    const toggleRow1 = (index) => {
        if (expandedRows.includes(index)) {
            setExpandedRows(expandedRows.filter((i) => i !== index));
        } else {
            setExpandedRows([...expandedRows, index]);
        }
    };
    const toggleRow = (index) => {
        // If the row is already expanded, collapse it
        if (expandedRows.includes(index)) {
            setExpandedRows(expandedRows.filter((i) => i !== index));
        } else {
            // Otherwise, collapse all previous rows and expand the current row
            setExpandedRows([index]); // Only keep the clicked row expanded
        }
    };
    

    const handleDropdownChange = (event, index) => {
        const selected = event.target.value;
        setSelectedOptions((prevState) => ({
            ...prevState,
            [index]: selected,
        }));

        if (selected === '+ Add New Customer') {
            setShowDialog(true);
        }
    };

    const handleInputChange = (event, index) => {
        const { id, value } = event.target;
        setInputValues((prevValues) => ({
            ...prevValues,
            [`${id}-${index}`]: value,
        }));
    };

    const quotesData = [
        { quote: '1239705', customer: 'Test Customer', refNo: '', createdBy: 'Mark', date: 'Feb 07 2025', tags: '', notes: 'Special notes for this quote.' },
        { quote: '1239704', customer: 'Paul', refNo: '234', createdBy: 'Arik Greenberg', date: 'Feb 05 2025', tags: 'urgent', notes: 'This quote is urgent!' },
        { quote: '1239703', customer: 'Pilco Inc.', refNo: '567', createdBy: 'Igor Popov', date: 'Jan 31 2025', tags: 'important', notes: '' },
        // ... Add more quotes as needed
    ];

    //return (<WAppearance />);
    return (
        <div className="quotes-container">
            <NewCustomerDialog show={showDialog} onClose={() => setShowDialog(false)} />
            <div>
      <SqlInsertGenerator templates={templates} productType="windows" />
    </div>
                <WAppearance />
            <table>
                <thead>
                    <tr>
                        <th>Quote No.</th>
                        <th>Customer</th>
                        <th>Reference No.</th>
                        <th>Created By</th>
                        <th>Date</th>
                        <th>Tags</th>
                    </tr>
                </thead>
                <tbody>
                    {quotesData.map((quote, index) => (
                        <React.Fragment key={index}>
                            <tr className="quote-row" onClick={() => toggleRow(index)}>
                                <td>{quote.quote}</td>
                                <td>{quote.customer}</td>
                                <td>{quote.refNo}</td>
                                <td>{quote.createdBy}</td>
                                <td>{quote.date}</td>
                                <td>{quote.tags}</td>
                            </tr>

                            {/* Expanded Row for Notes and More Details */}
                            {expandedRows.includes(index) && (
                                <tr className="quote-details">
                                    <td colSpan="6">
                                        <div>
                                            <h5 class='quote-details-heading'>Quote Details {quote.quote}</h5>
                                            <div className="form-group">
                                                <select
                                                    id={`customer-select-${index}`}
                                                    value={selectedOptions[index] || quote.customer}
                                                    onChange={(event) => handleDropdownChange(event, index)}
                                                >
                                                    <option value="" disabled></option>
                                                    <option value="+ Add New Customer">+ Add New Customer</option>
                                                    <option value={quote.customer}>{quote.customer}</option>
                                                </select>
                                                <label htmlFor={`customer-select-${index}`}>Customer:</label>
                                            </div>
                                            <div className="form-group">
                                                <input
                                                    type="text"
                                                    id={`refno-box-${index}`}
                                                    name={`refno-box-${index}`}
                                                    value={inputValues[`refno-box-${index}`] || quote.refNo}
                                                    //value={quote.refNo} //{inputValues[`text-box-${index}`] || ''}
                                                    onChange={(event) => handleInputChange(event, index)}
                                                    placeholder="ref No"
                                                />
                                                <label htmlFor={`refno-box-${index}`}>ref No</label>
                                            </div>
                                            <div className="form-group">
                                                <input
                                                    type="text"
                                                    id={`tags-box-${index}`}
                                                    name={`tags-box-${index}`}
                                                    value={inputValues[`tags-box-${index}`] || quote.tags}
                                                    //value={quote.refNo} //{inputValues[`text-box-${index}`] || ''}
                                                    onChange={(event) => handleInputChange(event, index)}
                                                    placeholder="tags"
                                                />
                                                <label htmlFor={`tags-box-${index}`}>tags</label>
                                            </div>
                                            {/* Notes section now using a textarea */}
                                            <div className="form-group">
                                                <textarea
                                                    id={`notes-${index}`}
                                                    name={`notes-${index}`}
                                                    value={inputValues[`notes-${index}`] || quote.notes}
                                                    onChange={(event) => handleInputChange(event, index)}
                                                    placeholder="Add notes here"
                                                />
                                                <label htmlFor={`notes-box-${index}`}>Notes</label>
                                            </div>
                                            <AddItem />
                                        </div>
                                    </td>
                                </tr>
                            )}
                        </React.Fragment>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default Quotes;
